module.exports = __webpack_public_path__ + "static/media/TanqueFisico.1528bd53.jpg";